import { shallowMount } from "@vue/test-utils";
import JobOccupation from "@/components/core/composite/combos/JobOccupation";

describe("JobOccupation component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(JobOccupation);
  });

  it("Renders del component JobOccupation", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
